import { Paper, styled } from '@mui/material';

export const CalendarPanel = styled(Paper, {
  shouldForwardProp: (propName) => propName !== 'size'
})<{ size: 'FULL' | 'SLIM' }>(({ size }) => ({
  boxSizing: 'border-box',
  flex: 3,
  minWidth: size === 'FULL' ? '450px' : '350px',
  height: 'fit-content',
  minHeight: '100%'
}));
